import { render } from "./states.vue?vue&type=template&id=164e7fb0"
import script from "./states.vue?vue&type=script&lang=js"
export * from "./states.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__